<template lang="pug">
.list-of-grids
    .flex.flex-wrap.-m-2
        .w-full.p-2
            .block.bg-gray-200.p-4.rounded
                | 12 of 12
        div.p-2(class="w-1/2")
            .bg-gray-200.p-4.rounded
                | 6 of 12
        div.p-2(class="w-1/2")
            .bg-gray-200.p-4.rounded
                | 6 of 12
        div.p-2(class="w-1/3")
            .bg-gray-200.p-4.rounded
                | 4 of 12
        div.p-2(class="w-1/3")
            .bg-gray-200.p-4.rounded
                | 4 of 12
        div.p-2(class="w-1/3")
            .bg-gray-200.p-4.rounded
                | 4 of 12
        div.p-2(class="w-1/4")
            .bg-gray-200.p-4.rounded
                | 3 of 12
        div.p-2(class="w-1/4")
            .bg-gray-200.p-4.rounded
                | 3 of 12
        div.p-2(class="w-1/4")
            .bg-gray-200.p-4.rounded
                | 3 of 12
        div.p-2(class="w-1/4")
            .bg-gray-200.p-4.rounded
                | 3 of 12
        div.p-2(class="w-1/6")
            .bg-gray-200.p-4.rounded
                | 2 of 12
        div.p-2(class="w-1/6")
            .bg-gray-200.p-4.rounded
                | 2 of 12
        div.p-2(class="w-1/6")
            .bg-gray-200.p-4.rounded
                | 2 of 12
        div.p-2(class="w-1/6")
            .bg-gray-200.p-4.rounded
                | 2 of 12
        div.p-2(class="w-1/6")
            .bg-gray-200.p-4.rounded
                | 2 of 12
        div.p-2(class="w-1/6")
            .bg-gray-200.p-4.rounded
                | 2 of 12
</template>

<script>
export default {
    name: 'grids'
}
</script>

<style lang="sass">

</style>
